import { ActionReducerMap } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import {IAppState} from '../states/app.state';
import { snakeReducers } from './snake.reducer';

export const appReducers : ActionReducerMap<IAppState, any> = {
	snake: snakeReducers,
	router: routerReducer
}